import { t } from "../core/i18n.js";
import { hideToast, toast } from "../core/navigation.js";

// One pending undo at a time, like Notion and Gmail: the newest deletion wins.
const UNDO_WINDOW = 10000;
let pending = null;

export const modKey = () =>
  /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)
    ? "⌘"
    : "Ctrl";

export function offerUndo(message, restore) {
  pending = { restore, expires: Date.now() + UNDO_WINDOW };
  toast(message, {
    action: t("Undo"),
    shortcut: `${modKey()} Z`,
    duration: 6000,
    onAction: undoLast,
  });
}

export function undoLast() {
  if (!pending || pending.expires < Date.now()) {
    pending = null;
    return false;
  }
  const { restore } = pending;
  pending = null;
  hideToast();
  restore();
  return true;
}
